import BuyNow from './buy-now';

export default BuyNow;
